export class Logger {
    public static captureError(
        msg: string,
        domain: 'Sportsbook' | 'internal' | 'Players',
        context?: Record<string, unknown>
    ): void {
        console.error(`[${domain}] ${msg}`, context ?? {});
    }
}
